<template>
  <div class="directory-add wbg">
    <div class="center-form">
      <a-form-model ref="addForm" :model="form" :label-col="{ span: 8 }" :rules="rules" :wrapper-col="{ span: 12 }">
        <a-form-model-item label="法院名称：" prop="title">
          <a-input v-model="form.title" placeholder="请输入法院名称" style="width: 397px;"
            :disabled="edit ? true : (id ? !editing : false)" />
          <div class="btns" v-if='$common.AUTH("court:edit") && id && !edit'>
            <a-button icon="edit" size='small' v-if='!editing' @click='editing = true' type='link'>修改</a-button>
            <a-button type='link' icon="check" size="small" v-if='editing' @click='nameEdit'>提交</a-button>
            <a-button type='link' icon="close" size="small" v-if='editing' @click='editing = false'
              style="color:#f00;">取消</a-button>
          </div>
        </a-form-model-item>
        <a-form-model-item label="立案庭地址：" prop="province">
          <a-row>
            <a-cascader :disabled="edit || editing || isEdit(30)" :options="options" :value="address"
              placeholder="请选择立案庭地址" :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }"
              @change="onChange" style="width: 397px;" />
          </a-row>
          <a-row>
            <a-input v-model="form.addr" placeholder="请输入立案庭详细地址" style="width: 397px;"
              :disabled="edit || editing || isEdit(30)" />
          </a-row>
        </a-form-model-item>

        <a-form-model-item label="诉讼立案要求：" prop="ssla_limit">
          <a-textarea v-model="form.ssla_limit" placeholder="诉讼立案要求（选填）" style="width: 397px;height:80px;"
            :disabled="edit || editing || isEdit(30)" />
        </a-form-model-item>
        <a-form-model-item label="联系人姓名：" prop="uname">
          <a-input v-model="form.uname" placeholder="请输入联系人姓名（选填）" style="width: 397px;"
            :disabled="edit || editing || isEdit(30)" />
        </a-form-model-item>
        <a-form-model-item label="联系电话：" prop="phone">
          <a-input v-model="form.phone" placeholder="请输入联系电话（选填）" style="width: 397px;"
            :disabled="edit || editing || isEdit(30)" />
        </a-form-model-item>
        <a-form-model-item label="执行立案要求：" prop="zxla_limit">
          <a-textarea v-model="form.zxla_limit" placeholder="执行立案要求（选填）" style="width: 397px;height:80px;"
            :disabled="edit || editing || isEdit(30)" />
        </a-form-model-item>

        <a-form-model-item label="联系人姓名：" prop="zxla_uname">
          <a-input v-model="form.zxla_uname" placeholder="请输入执行联系人姓名（选填）" style="width: 397px;"
            :disabled="edit || editing || isEdit(30)" />
        </a-form-model-item>
        <a-form-model-item label="联系电话：" prop="zxla_phone">
          <a-input v-model="form.zxla_phone" placeholder="请输入执行联系电话（选填）" style="width: 397px;"
            :disabled="edit || editing || isEdit(30)" />
        </a-form-model-item>
        <a-form-model-item label="执行局地址：" prop="zxj_province">
          <a-row>
            <a-cascader :disabled="edit || editing || isEdit(30)" :options="options" :value="zxj_address"
              placeholder="请选择执行局地址" :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }"
              @change="onzxjChange" style="width: 397px;" />
          </a-row>
          <a-row>
            <a-input v-model="form.zxj_addr" placeholder="请输入执行局详细地址" style="width: 397px;"
              :disabled="edit || editing || isEdit(30)" />
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="其他要求备注：" prop="other_comment">
          <a-textarea v-model="form.other_comment" placeholder="其他要求备注" style="width: 397px;height:80px;"
            :disabled="edit || editing || isEdit(30)" />
        </a-form-model-item>
        <a-form-model-item prop="files" :wrapper-col="{ span: 24 }"
          :rules="{ required: false, message: '请上传附件', trigger: 'change' }">
          <Upload @isDisabled="parentHandle" :fList='form.files' @upFileAfter='lisUpload' Wid='140px' v-if='loading'
            style="width:50%;margin:0 auto;" :edit="edit || editing || isEdit(30)" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 8 }" v-if="!edit && !editing" class="subbtn">
          <a-button type="danger" v-if='id && isEdit(30)'>审核中</a-button>
          <a-button type="primary" @click="onSubmit()" v-if='$common.AUTH("court:editWithAudit") && !isEdit(30)'
            :disabled="disabledShow">提交</a-button>
          <a-button class="cancel" type="primary" @click="cancel()" style="margin-left: 30px;">返回</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import { getDistricts } from "@/server/api"
import { directoryInfo, directoryEdit, directoryAdd, directoryNameEdit } from "@/server/directory"
import Validator from "@/assets/js/yz"
import Upload from "@/components/uploads"
import city from "@/assets/js/city.json"
import { citySort } from '@/assets/js/unit'
export default {
  data() {
    return {
      options: citySort(city),
      loading: false,
      id: this.$route.query.id || '',
      editing: false,
      audit: [],
      form: {
        title: '',
        province: '',
        ssla_limit: '',
        city: '',
        area: '',
        addr: '',
        zxj_province: '',
        zxj_city: '',
        zxj_area: '',
        uname: '',
        zxla_limit: '',
        phone: '',
        zxla_phone: '',
        zxla_uname: '',
        zxj_addr: '',
        files: [],
        other_comment: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入法院名称', trigger: 'blur' },
          { message: '法院名称只能是汉字、字母和数字', trigger: 'blur', validator: Validator.companyName }
        ],
        province: { required: true, message: '请选择省市区', trigger: 'change' },
        zxj_province: { required: true, message: '请选择省市区', trigger: 'change' },
        uname: { message: '联系人只能是汉字、字母', trigger: 'blur', validator: Validator.name },
        phone: { message: '请输入正确的手机号或座机号', trigger: 'blur', required: false },
        zxla_uname: { message: '联系人只能是汉字、字母', trigger: 'blur', validator: Validator.name },
        zxla_phone: { message: '请输入正确的手机号或座机号', trigger: 'blur', required: false }
      },
      zxj_address: [],
      address: [],
      disabledShow: false
    }
  },
  computed: {
    edit() {
      return this.$route.query.t
    }
  },
  created() {
    // this.getAddress();
    if (this.id) {
      this.getInfo()
    } else {
      this.loading = true
    }
  },
  components: { Upload },
  methods: {
    parentHandle(data) {
      this.disabledShow = data
    },
    isEdit(val) {
      let bool = this.audit.filter(ele => {
        return ele.type == val
      }).length > 0 ? true : false;
      return bool
    },
    nameEdit() {
      if (!this.form.title) {
        this.$message.error('请输入法院名称')
        return false;
      }
      if (!/^([^\u0000-\u00FF]|[a-zA-Z]|\d)*$/g.test(this.form.title)) {
        this.$message.error('法院名称只能是汉字、字母和数字')
        return false;
      }
      directoryNameEdit({ id: this.id, title: this.form.title }).then(e => {
        this.$message.success({ content: '修改成功' });
        this.$router.replace('/directory/manager');
      })
    },
    lisUpload(fileList) {
      this.$set(this.form, 'files', fileList)
    },
    getAddress() {
      getDistricts().then((res) => {
        this.options = citySort(res.list)
      })
    },
    getInfo() {
      directoryInfo({
        id: this.id
      }).then((res) => {
        this.address = [res.info.province, res.info.city, res.info.area]
        this.zxj_address = [res.info.zxj_province, res.info.zxj_city, res.info.zxj_area]
        for (const key in this.form) {
          this.form[key] = res.info[key]
        }
        this.audit = res.info.audit
        this.loading = true;
      })
    },
    phoneVali(rule, value, callback) {//手机号
      if (!value) {
        return callback();
      }
      setTimeout(() => {
        if (/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(value) || /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的手机号或座机号'));
        }
      }, 200);
    },
    onChange(val) {
      this.address = val
      if (val.length > 0) {
        this.form.province = val[0]
        this.form.city = val[1]
        this.form.area = val[2]
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    onzxjChange(val) {
      this.zxj_address = val
      if (val.length > 0) {
        this.form.zxj_province = val[0]
        this.form.zxj_city = val[1]
        this.form.zxj_area = val[2]
      } else {
        this.form.zxj_province = ''
        this.form.zxj_city = ''
        this.form.zxj_area = ''
      }
    },
    onSubmit() {
      if (this.id) {
        delete this.rules.title
      }
      this.$refs.addForm.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          // if (!this.form.addr) {
          //   this.$message.error({ content: '请输入详细地址' });
          //   return false
          // }
          form.files = form.files.map(ele => {
            return ele.id || ele
          })
          if (this.id) {
            delete form.title
            directoryEdit(Object.assign(form, { id: this.id })).then((res) => {
              this.$message.success({ content: '已提交审核' });
              this.$router.replace('/directory/manager');
            })
          } else {
            directoryAdd(form).then((res) => {
              this.$message.success({ content: '添加成功' });
              this.$router.replace('/directory/manager');
            })
          }
        }
      })
    },
    cancel() {
      this.$router.replace('/directory/manager');
    }
  }
}
</script>
<style lang="less" scoped>
.btns {
  display: inline-block;
  font-size: 1.25rem;
  margin-left: 10px;
  color: #009688;
}

.directory-add {
  padding-top: 60px;
  min-height: 860px;
}

/deep/ .ant-input {
  height: 40px;
}

.ant-select {
  width: 114px;
  margin-right: 27px;
  margin-bottom: 10px;
  height: 40px;

  /deep/ .ant-select-selection--single {
    height: 40px;
  }

  /deep/ .ant-select-selection__rendered {
    line-height: 40px;
  }
}

.ant-cascader-picker {
  margin-bottom: 10px;
}

.ant-form-item {
  margin-bottom: 30px;
}

.ant-form-item-with-help {
  margin-bottom: 11px;
}

/deep/ .ant-form label {
  font-size: 1rem;
  color: #0e2949;
}

.subbtn {
  button.ant-btn {
    width: 150px;
    margin-top: 10px;
  }

  button.ant-btn.cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
  }
}
</style>
